import React, { createContext, ReactNode, useContext, useState } from 'react';

interface SidebarContextType {
  refreshHistory: () => void;
  triggerHistoryRefresh: boolean;
}

const SidebarContext = createContext<SidebarContextType>({
  refreshHistory: () => {},
  triggerHistoryRefresh: false,
});

export const useSidebarUpdate = () => useContext(SidebarContext);

type SidebarProviderProps = {
  children: ReactNode;
};

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ children }) => {
  const [triggerHistoryRefresh, setTriggerHistoryRefresh] = useState(false);

  const refreshHistory = () => {
    setTriggerHistoryRefresh((prev) => !prev);
  };

  return (
    <SidebarContext.Provider
      value={{
        refreshHistory,
        triggerHistoryRefresh,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
